<template>
<div class="doc-slution-page">
   <div class="content" v-if="$route.params.id==1">
    <h2>档案数字化服务</h2>
    <div class="text-content-h5">	
      <div class="text-item">		
        <p>项目进场→软硬件安装→项目人员到岗→项目试运行→档案收集→档案交接→</p><p>档案前整理（包括缺失审查、档案分卷、档案排序、去杂物、修补、托裱、展平、图纸折叠、打页码）→</p>	
        <p>档案扫描→扫描质检→图像处理→图像质检→条目著录→著录质检→封面备考表脊背信息制作与完善→</p>		
        <p>实体档案装订上架→电子数据抽检→数据上传及挂接→数据备份→项目最终验收<br></p>			
      <h4>档案数字化全过程:</h4>		
      <ul class="text-ul">			
          <li>				
          <img src="https://hz.chenksoft.com:443//upload/image/39379640464258725.png" alt="" style="max-width:100%;" class=""></li>	
      </ul>		  	
      </div> 
      <div class="text-item">	
        <h4>加工项目管理规范</h4>	
      </div>	
      <div class="text-item text-item-grey">	
        <ul class="text-ul">		
            <li>1、组织管理-现场实施团队-现场准备小组，人员保障小组，设备保障小组，技术保障小组，后勤保障小组，质量检测小组，安全保障小组</li>
            <li>2、现场管理-员工纪律准则，库房管理制度，物品管理制度，操作管理制度，考勤管理制度，值班管理制度，卫生管理制度</li>			
            <li>3、安全管理-现场安全-设备网络安全管理-数据存储安全管理，备份数据安全管理，工作现场封闭管理，监控设备安全管理，PC机存储安全管理	</li>	
            <li>4、实施保障-人员保障规范（本地化服务和重点培养），设备保障规范（日常保养、厂商合作、日常储备），整体保障规范（档案基础知识和业务指导），产量保障规范（增加生产线、人员保障、设备保障），质量保障规范（岗位培训和绩效考核），培训保障规范（聘请专家和带教）</li>
            <li>5、质量管理-质量管理规范-质量控制流程（流程化作业模式），质量检查制度（PDCA持续改进机制），质量保障措施（自检、抽样检查等），放差错率措施（人防技防双管齐下）	</li>				
            <li>6、保密管理-项目保密规范，人员保密规范，载体保密规范，现场保密规范，泄密处理规范，保密工作纪律</li>	
        </ul>	
      </div>
      <div class="text-item">
        <h4>主要流程图</h4>
        <div class="center-img">
          <img src="https://hz.chenksoft.com:443//upload/image/609110349145012.png" alt="图片2" style="max-width:100%;">
          <p style="line-height: 1.8;text-align: center;">(接受流程)</p>
        </div>
        <div class="center-img">
          <img src="https://hz.chenksoft.com:443//upload/image/19342500366451976.png" alt="图片3" style="max-width:100%;">
          <p style="line-height: 1.8;text-align: center;">(档案装订流程)</p>	
        </div>
        <div class="center-img">
          <img src="https://hz.chenksoft.com:443//upload/image/662263362152306.png" alt="图片4" style="max-width:100%;">
          <p style="line-height: 1.8;text-align: center;">(档案扫描流程)</p>	
        </div>
        <div class="center-img">
          <img src="https://hz.chenksoft.com:443//upload/image/9129384901982167.png" alt="图片5" style="max-width:100%;">			
          <p style="line-height: 1.8;text-align: center;">(图像处理流程图)</p>	
        </div>
      </div>				
    </div>
   </div>
   <div class="content" v-else-if="$route.params.id==2">
     <h2>文件档案管理系统</h2>
     <div class="text-content-h5">
			<div class="text-item">		
			<h4>面临难题</h4>	
				<ul class="text-ul">	
					<li>1、<span style="line-height: 1.8;">文件分散管理，无法共享，查询检索不方便</span></li>	
					<li>2、<span style="line-height: 1.8;">权限不清晰，机密文件容易泄露</span></li>	
					<li>3、<span style="line-height: 1.8;">员工离职、调岗，造成文件丢失</span></li>		
					<li>4、<span style="line-height: 1.8;">文件版本混乱，无法及时同步更新到最新版本</span></li>			
					<li><span style="line-height: 1.8;">5、</span><span style="line-height: 1.8;">无法协同编辑同一个文件，协作效率低</span></li>
				</ul>	
			</div>	
			<div class="text-item">	
				<div class="center-img">
					<img src="https://hz.chenksoft.com:443//upload/image/5363184218457879.jpg" alt="图片1" style="max-width:100%;"><br><p style="text-align: center;">（系统流程图）</p>
					<img src="https://hz.chenksoft.com:443//upload/image/15867381704383843.jpg" alt="图片2" style="max-width:100%;"><br><p style="text-align: center;">（网络架构）</p>     
					<img src="https://hz.chenksoft.com:443//upload/image/3838701413800396.png" alt="" style="max-width:100%;"><br> <p style="text-align: center;">（功能介绍）</p>		
				</div>				
			</div>			
			<div class="text-item">			
				<h4>功能特点</h4>			
				<div>						
					<h5>分类管理</h5>			
					<p>文件分类可设置分类代码，系统自动根据分类代码规则自动生成文件编号。</p>			
				</div>					
				<div class="center-img"> 
					<img src="https://hz.chenksoft.com:443//upload/image/831460308421381.png" alt="B0642FBE-BF7A-47b3-9C50-37FB2AF2BAC0" style="max-width:100%;">
				</div>
				<div>
					<h5>文件上传</h5>	
					<p>文件分类可设置分类代码，系统自动根据分类代码规则自动生成文件编号。</p>			
				</div>	
				<div class="center-img">
					<img src="https://hz.chenksoft.com:443//upload/image/7270274012518136.png" alt="EEE8DDF5-1473-4f8a-9DD3-A4DEF054081A" style="max-width:100%;" class="">	
				</div>			
				<div>		
					<h5>在线编辑</h5>
					<p>系统支持office系列的文件在线编辑，无需下载到本地，可直接进行在线打开，每保持一次，系统对应自动生成一个新的版本。</p>			
				</div>	
				<div class="center-img">
					<img src="https://hz.chenksoft.com:443//upload/image/9127496352892035.png" alt="" style="max-width:100%;">		
				</div>				
				<div>		
					<h5>版本管理</h5>	
					<p>详情中，可看到文件的所有版本信息，每在线编辑一次，系统自动保存新的版本，上传文件时系统自动检测。</p>			
				</div>
				<div class="center-img">
					<img src="https://hz.chenksoft.com:443//upload/image/8634376189641815.png" alt="743A431F-D02C-4e78-A85F-63B214A9C148" style="max-width:100%;">	
				</div>							
			</div>	
		</div>
   </div>
   <div class="content" v-else-if="$route.params.id==3">
     <h2>移动APP档案管理系统</h2>
     <div class="text-content-h5">
      <div class="text-item">
        <h4>主要功能图片</h4>
        <p><img src="https://hz.chenksoft.com:443//upload/image/0980830168017004.png" alt="未标题-1" class=""><br></p>
      </div>
      <div class="text-item">
        <div><h5>参考图：</h5></div>
        <ul class="two-img">
          <li><img src="https://hz.chenksoft.com:443//upload/image/10136260879051862.png" alt="合" style="max-width:100%;" class=""><br></li>
        </ul>
      </div>
      <div class="text-item">
        <div><h5>档案保管</h5><p>利用虚拟库房实现与实体档案库房库存信息一致，使用户在线就能了解到实体库房的所有信息。</p></div>
        <ul class="two-img"><li><img src="https://hz.chenksoft.com:443//upload/image/505748081083373.png" alt="合2" style="max-width:100%;"><br></li></ul>
      </div>
      <div class="text-item">
        <div><h5>开发利用</h5><p>以利用者为服务对象，以库藏档案为服务手段，采用多种利用形式和方法，开发和直接提供档案为各项工作服务。</p></div>
        <ul class="two-img"><li><img src="https://hz.chenksoft.com:443//upload/image/18588414179439394.png" alt="合3" style="max-width:100%;"><br></li></ul>					</div>
      </div>
   </div>
   <div class="content" v-else-if="$route.params.id==4">
    <h2>智慧档案室</h2>
    <div class="text-content-h5">
        <div class="text-item">  
        <h4>面临问题</h4>	
          <ul class="text-ul">		
            <li>1、档案查找困难；有人借阅档案时，档案管理人员需花费大量的时间进行查找，工作效率低下</li>	
            <li>2、档案借出状态无法准确及时掌握；实体档案外借后存在安全风险；档案资料往往只有一份，无法实现多人同时借阅</li>				
            <li>3、借阅手续繁琐，使得借阅人员的档案借阅意愿不强烈，导致档案利用率低，管理者不愿投入资源到档案管理工作中</li>		
        
          </ul>	
          <div class="center-img">
          <img src="https://hz.chenksoft.com//upload/image/08346711417111607.png" alt="">	
        </div>
          <p style="text-align: center;">（网络架构）</p>		
      </div>		
      <div class="text-item">		
        <h4>各个子系统协同工作，安全高效</h4>		
        <div class="center-img">
          <img src="https://hz.chenksoft.com//upload/image/28234616648679345.png" alt="">		
        </div>		
      </div>		
      <div class="text-item">		
        <h4>系统架构图</h4>
        <div class="center-img">
          <img src="https://hz.chenksoft.com//upload/image/09234629153057061.png" alt="">
        </div>				
      </div>		
      <div class="text-item">			
        <h4>平面布局图</h4>	
        <div class="center-img">
          <img src="https://hz.chenksoft.com//upload/image/47207051201088146.png" alt="">		
          <img src="https://hz.chenksoft.com//upload/image/5509830007533425.png" alt="">		
        </div>				
      </div>		
		</div>
   </div>
   <div class="content" v-else-if="$route.params.id==5">
     <h2>房地产行业档案管理</h2>
     <div class="text-content-h5">
       <div class="text-item">
        <h4>面临挑战</h4>
        <ul class="text-ul"><li>1、<span style="line-height: 1.8;">部门各种计划、方案、规划、报告；图纸、 协议书、合同等无法集中分类管理，造成丢失，容易引起法律纠纷</span></li>  	<li>2、<span style="line-height: 1.8;">公司档案门类众多，查找起来困难重重，无法高效利用与借阅</span></li>    				<li>3、<span style="line-height: 1.8;">档案随时有损坏或丢失的风险</span></li>		<li><span style="line-height: 1.8;">4、</span><span style="line-height: 1.8;">档案利用效率低，档案及档案管理人员的工作价值难以体现</span></li> 	</ul>
       </div>
       <div class="text-item">
        <h4>管理目标</h4>
        <div>	<p>房地产企业档案的业务特点发挥自身在电子文档管理软件上的技术优势，房地产企业从前期事务、设计、施工、竣工一直到销售和项目结案的所有文档资料进行科学的立卷管理， 实现档案的规范化、数字化、信息化管理</p>						</div>
        <div>					<h5>房地产企业档案归档范围</h5>				</div>
        <div class="center-img">					<img src="https://hz.chenksoft.com:443//upload/image/6583086387405905.png" alt="图片3" style="max-width:100%;" class=""><span style="font-weight: normal;"><br></span><p></p>							</div>
       </div>
       <div class="text-item">
        <h4>归档范围</h4>
        <div>					<h5>房地产建设项目档案归档范围</h5>				</div>
        <div class="center-img">					<img src="https://hz.chenksoft.com:443//upload/image/1640044454527647.png" alt="图片2" style="max-width:100%;" class=""><br><p></p>						</div>
       </div>
       <div class="text-item">
        <h4>功能特点</h4>
        <div>					 <h5>自动归档</h5>				 </div>
        <div class="center-img">						<img src="https://hz.chenksoft.com:443//upload/image/496942874224628.png" alt="图片1" style="max-width:100%;" class="">				</div>
        <div>					<h5>审批集成</h5>				</div>
        <div class="center-img">						<img src="https://hz.chenksoft.com:443//upload/image/6594669530293464.png" alt="" style="max-width:100%;">				</div>
        <div>					<h5>对接框架模型</h5>				</div>
        <div class="center-img"><img src="https://hz.chenksoft.com:443//upload/image/5913361146548346.png" alt="图片" style="max-width:100%;"><br><p></p>							</div>
       </div>
     </div>
   </div>
   <div class="content" v-else-if="$route.params.id==6">
    <h2>会计行业档案管理</h2>
    <div class="text-content-h5">					 <div class="text-item">    							 <h4>面临问题</h4>   								<ul class="text-ul">  									<li>1、<span style="line-height: 1.8;">纸质会计档案打印量大，存储成本高</span></li> 									<li>2、<span style="line-height: 1.8;">电子和纸质档案共存的情况下，管理难度大</span></li>  									<li>3、<span style="line-height: 1.8;">纸质会计档案容易损坏、丢失、泄密</span></li>												<li><span style="line-height: 1.8;">4、</span><span style="line-height: 1.8;">档案归档、检索、借阅、鉴定效率低，档案共享程度差</span></li>											<li><span style="line-height: 1.8;">5、</span><span style="line-height: 1.8;">档案调阅、日常管理记录不完整或不规范，难追溯</span><img src="https://hz.chenksoft.com:443//upload/image/6984793288145816.png" alt="2924925214389431~1" style="max-width:100%;"></li>  								</ul>  							<div class="center-img">								</div>  		 									<div class="text-item">									<h4>档案保管期限表</h4>									<div>										<h5>企业和其他组织会计档案保管期限表</h5>								</div>										<div class="center-img">								<img src="https://hz.chenksoft.com:443//upload/image/2834417614336209.png" alt="" style="line-height: 1; max-width: 100%;">									</div>										</div>							<div class="text-item">													<div>																				 <h5>财政总预算、行政单位、事业单位和税收会计档案保管期限表</h5>																							 </div>																								 <div class="center-img">																												 <img src="https://hz.chenksoft.com:443//upload/image/3291561782373196.png" alt="" style="max-width:100%;">				</div>				</div>					</div><p><br></p></div>
   </div>
   <div v-else></div>
</div>
</template>
<script>
import TitleBar from '../components/TitleBar.vue'


import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'

export default {
  name: 'DocSolutionPage',
  components: {
    TitleBar
  },
  data() {
    return {
      routeId:'',
      activeName: 'tab0',
    }
  },
  methods: {
    
  },
  created: function(){
   
  },
  watch: {
    
  },
}
</script>
<style lang="scss">
.doc-slution-page{
  background: #f8f8f8;
  padding-top: 3rem;
  padding-bottom: 3rem;
  font-size: 0.75rem;
  line-height: 1.5;
  .center-img{
    text-align: center;
  }
  .content{
    max-width: 1200px;
    background: #fff;
    margin: 0 auto;
    padding: 4rem 5rem;
    h2{
      font-size: 1.5rem;
      font-weight: 600;
      text-align: center;
      margin-bottom: 2rem;
    }
    .text-item{
      margin-bottom: 1rem;
      h4{
        font-size: 0.9rem;
        padding-bottom: 0.3rem;
        padding-top: 1rem;
        border-bottom: 1px dashed #dedede;
        margin-bottom: 1rem;
      }
      h5{
        font-size: 0.8rem;
        padding-bottom: 0.3rem;
      }
      img{
        max-width: 100%;
        padding-top: 1rem;
        padding-bottom: 1rem;
      }
      .img-text{
        text-align: center;
      }
      .two-img{
        text-align: center;
        li{
          width: 49%;
          margin-right: 1%;
          display: inline-block;
        }
      }
    }
  }
 
}
</style>